var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.045,
    height: 14.731,
    viewBox: "0 0 21.045 14.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contact.03ce526193c572b65a2c8faa2f110918",
    d: "M22.045,3.21a2.188,2.188,0,0,0-.661-1.563A2.276,2.276,0,0,0,19.79,1H3.255a2.274,2.274,0,0,0-1.594.647A2.184,2.184,0,0,0,1,3.21V13.522a2.188,2.188,0,0,0,.661,1.563,2.274,2.274,0,0,0,1.594.647H19.79a2.274,2.274,0,0,0,1.594-.647,2.188,2.188,0,0,0,.661-1.563ZM7.354,9.523,3.467,14.258h16.11L15.69,9.523a3.725,3.725,0,0,1-2.6,1.052H9.953a3.725,3.725,0,0,1-2.6-1.052ZM2.5,13.083,6.376,8.366,2.5,3.648v9.434ZM16.668,8.366l3.872,4.717V3.648L16.669,8.366ZM3.467,2.473,8.255,8.3a2.192,2.192,0,0,0,1.7.8h3.138a2.2,2.2,0,0,0,1.7-.8l4.787-5.831Z",
    transform: "translate(-1 -1)",
    fill: "#999",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactlight);
export default __webpack_public_path__ + "static/media/contactlight.2ab482b21858305acb8d659579c755d5.svg";
export { ForwardRef as ReactComponent };